import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";

export interface CategoryQueryParam {
  search?: string;
}

export const useGetCategoryQuery = ({ search }: CategoryQueryParam) => {
  const token = localStorage.getItem("BETTY_ADMIN_USER_TOKEN");

  const queryParams = new URLSearchParams();

  if (search) queryParams.append("search", search);

  // const url = search
  //   ? '/products/categories'
  //   : `/products?${queryParams.toString()}`;

  return useQuery({
    queryKey: ["useGetCategory", { search }],
    queryFn: () =>
      axiosInstance
        .get("/products/categories", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),

    // onError: (error: any) => {
    //   message.error(error?.response?.data?.message);
    // },
    enabled: !!token,
  });
};
